"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var useStyles = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        subtitle: {
            textTransform: 'uppercase',
            marginLeft: '2px',
        },
        fieldset: {
            color: theme.palette.text.secondary,
            margin: "16px",
            marginTop: "32px",
        },
        topo: {
            borderBottom: '1px solid #e0e0e0',
            marginBottom: '-20px',
            marginLeft: '1%',
            marginRight: '1%',
        },
        wrap: {
            borderLeft: '5px solid',
            borderColor: theme.palette.primary.main,
            boxShadow: '1px 1px 5px lightgrey',
            padding: '10px 0 10px 0',
            marginBottom: '20px',
        },
    });
});
function Fieldset(props) {
    var classes = useStyles({});
    return (React.createElement("div", { className: classes.wrap },
        React.createElement("div", { className: classes.topo },
            React.createElement(core_1.Typography, { variant: "subtitle1", align: "left", color: "textSecondary", className: classes.subtitle, noWrap: true }, props.subtitle)),
        React.createElement("div", { className: classes.fieldset }, props.children)));
}
exports.default = Fieldset;
//# sourceMappingURL=Fieldset.js.map